// @ts-nocheck
export const localeCodes =  [
  "en",
  "vi",
  "cn"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46yml_02d9d988",
      load: () => import("#nuxt-i18n/02d9d988" /* webpackChunkName: "locale_en_46yml_02d9d988" */),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46yml_1a4d57d6",
      load: () => import("#nuxt-i18n/1a4d57d6" /* webpackChunkName: "locale_vi_46yml_1a4d57d6" */),
      cache: true
    }
  ],
  cn: [
    {
      key: "locale_cn_46yml_60c39316",
      load: () => import("#nuxt-i18n/60c39316" /* webpackChunkName: "locale_cn_46yml_60c39316" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/db1d7050" /* webpackChunkName: "config_i18n_46config_46ts_db1d7050" */)
]
export const normalizedLocales = [
  {
    name: "English",
    code: "en",
    iso: "en",
    dir: "ltr",
    language: "en"
  },
  {
    name: "Tiếng Việt",
    code: "vi",
    iso: "vi",
    dir: "ltr",
    language: "vi"
  },
  {
    name: "中国人",
    code: "cn",
    iso: "cn",
    dir: "ltr",
    language: "cn"
  }
]
/** client **/

/** client-end **/